import { gql } from "apollo-boost";

export const BOOST_DATA_QUERY = gql`
  query ($email: String!) {
    info: getBoostData(email: $email){
      status
      productTier
      productTerm
      productFreeTrial
      pastDueAmount
      startDate
      boostCreditReportingLimit
      subscription {
        id
        customerId
        willResumeAt
        willCancelAt
        billingCycleEndsAt
        status
        scheduledUpdate {
          startDate
          tier
          term
        }
      }
    }  
  }
`;
